module.exports = __webpack_public_path__ + "164b4d3b54a12475041a810bffbad2a2.svg";